import { useCallback } from 'react';

import { useAppContext } from '../../App/utils/useAppContext';
import { loadSession as loadSessionAction, startChatFail, updateChat } from '../actions';
import { TranscriptContextDispatcher } from '../types';
import { useTranscriptContext } from './useTranscriptContext';

export const useLoadSession = (externalDispatch?: TranscriptContextDispatcher) => {
  const contextDispatch = useTranscriptContext().dispatch;
  const dispatch = externalDispatch || contextDispatch;
  
  const {
    endpoints,
    state: { systemId, tenantId, userId },
  } = useAppContext();

  /**
   * Load a chat session by sessionId
   * @param sessionId {string} - Session ID to load
   * @returns {Promise<void>} - No return. It dispatches action to update chat
   */
  const loadSession = useCallback(
    async (sessionId: string) => {
      if (!endpoints.resumeChat) {
        return Promise.reject('resumeChat endpoint not provided');
      }

      if (!systemId || !tenantId || !userId) {
        return Promise.reject('Missing required config');
      }

      dispatch(loadSessionAction(sessionId));

      return endpoints
        .resumeChat({ systemId, tenantId, userId }, sessionId)
        .then((d) => {
          dispatch(updateChat(d));
        })
        .catch(() => {
          dispatch(startChatFail());
        });
    },
    [dispatch, endpoints, systemId, tenantId, userId],
  );

  return {
    loadSession,
  };
};

